import { DevToolsToggleButton } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsToggle/DevToolsToggleButton';
import { useDevToolsStore } from 'Modules/softphone/components/SoftphoneDevTools/store';
import React from 'react';
import { createPortal } from 'react-dom';
import { useShallow } from 'zustand/react/shallow';

/**
 * DevToolsToggle - Floating toggle button to enable/disable DevTools panel
 *
 * Fixed position at the right edge of the screen (like TanStack Query
 * DevTools). Mounted only by `SoftphoneDevTools`, which has already checked
 * access.
 */
export const DevToolsToggle: React.FC = () => {
  const { isOpen, toggle } = useDevToolsStore(
    useShallow((state) => ({ isOpen: state.isOpen, toggle: state.toggle }))
  );

  return createPortal(
    <DevToolsToggleButton isOpen={isOpen} onClick={toggle} />,
    document.body
  );
};
